module.exports = "<div class=\"products-manager\" layout=\"column\" layout-align=\"start\" layout-fill>\n  <!-- Header -->\n  <f-toolbar></f-toolbar>\n\n  <!-- Loader -->\n  <md-progress-linear class=\"products-manager__loading-indicator\" ng-show=\"$ctrl.loading\" md-mode=\"indeterminate\" class=\"md-warn\"></md-progress-linear>\n\n  <f-product-list\n    layout=\"column\"\n    flex\n    view-style=\"$ctrl.viewStyle\"\n    editable=\"true\"\n    feis=\"$ctrl.feis\">\n  </f-product-list>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/products/tpl.html
// module id = 1190
// module chunks = 0